export default "__VITE_ASSET__K8E4V5Ac__"